import React from "react";
import { Space, Button, Modal } from "antd";
import { useIntl } from "react-intl";
import { deleteConfirmMessage } from "../../../forms/formsFeedback";
import { getFullName } from "../../../util/helpers";

const ACTION_TYPES = {
  lead: {
    buttonText: "app.actions.convert_to_potential",
    buttonType: "primary",
  },
  opportunity: {
    buttonText: "app.actions.convert_to_active_patient",
    buttonType: "primary",
  },
};

const EntityActions = (props) => {
  const { onEdit, onConvert, onDelete, type, record } = props;
  const intl = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const launchDeleteConfirmation = () => {
    deleteConfirmMessage(
      intl,
      getFullName(record.surename, record.first_name),
      type,
      record.id,
      onDelete,
      modal
    );
  };
  const actionType = ACTION_TYPES[type];
  return (
    <div className="component">
      {contextHolder}
      <Space size="small">
        {type !== "opportunity" && (
          <Button onClick={onEdit}>
            {intl.formatMessage({
              id: `app.actions.edit`,
            })}
          </Button>
        )}
        {type !== "opportunity" && (
          <Button onClick={() => launchDeleteConfirmation()}>
            {intl.formatMessage({
              id: `app.actions.delete`,
            })}
          </Button>
        )}
        <Button type={actionType.buttonType} onClick={onConvert}>
          {intl.formatMessage({
            id: actionType.buttonText,
          })}
        </Button>
      </Space>
    </div>
  );
};
export default EntityActions;
